import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialog } from '../../../../models/confirmation-dialog';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../state';

@Component({
  selector: 'dashboard-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialog,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {}

  onConfirm() {
    if (this.data.onConfirm) {
      if (typeof this.data.onConfirm === 'function') {
        this.data.onConfirm();
      } else {
        this.store.dispatch(this.data.onConfirm);
      }
    }
    this.dialogRef.close();
  }

  onReject() {
    if (this.data.onReject) {
      if (typeof this.data.onReject === 'function') {
        this.data.onReject();
      } else {
        this.store.dispatch(this.data.onReject);
      }
    }
    this.dialogRef.close();
  }
}
